import { render, staticRenderFns } from "./StandaloneLink.vue?vue&type=template&id=0fc5d2fa&scoped=true&lang=pug&"
import script from "./StandaloneLink.vue?vue&type=script&lang=js&"
export * from "./StandaloneLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc5d2fa",
  null
  
)

export default component.exports